<template>
    <div id = "home">
        <body style="background-color: #292929">
            <header>
                <NavigationBar/>
            </header>
           
            <main style="background-color: #292929">
                <DigitizeBody/>
            </main>
           
            <footer style="background-color: #292929">
                <WebsiteFooter/>
            </footer>
        </body>
    </div>
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js"></script>

<script>
import NavigationBar from '../components/NavigationBar'
import DigitizeBody from '../components/DigitizeBody'
import WebsiteFooter from '../components/WebsiteFooter'

export default {
    name: "home",
    data(){
        return {}
    },

    components: {
        NavigationBar,
        DigitizeBody,
        WebsiteFooter
    }   
}
</script>